import type { BuiltinTokenMap } from '@visactor/vchart';

export const token: Partial<BuiltinTokenMap> = {
  fontFamily:
    // eslint-disable-next-line max-len
    `"PingFang SC", "-apple-system", "Segoe UI", "Helvetica Neue", Arial,
    Roboto, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
  fontSize: 12
};
